import React, { useState, useEffect } from "react";

const handleNumberOnClick = (e) => {
  // console.log(e);
  if (e.key === "." || e.key === "e" || e.key === "-") {
    e.preventDefault();
  }
};

const TablePagination = ({
  onPreviousPageClick,
  canPreviousPage,
  canNextPage,
  onNextPageClick,
  gotoPage,
  pageIndex,
  pageOptions,
  pageSize,
  pageCount,
  setPageSize,
}) => {
  // console.log("pagination");
  // console.log(pageCount);

  const [pageDisplay, setPageDisplay] = useState(pageIndex + 1);
  useEffect(() => {
    setPageDisplay(pageIndex + 1); //when page count changes, reinitialize this to pageIndex(handled by library)+1.
    // setPageDisplay(1); //we reset to the first page when a change to the table page count is made
  }, [pageIndex]);
  // console.log("Page Count:" + pageCount);
  // console.log("Page Index:" + pageIndex);
  // console.log("Page Display: " + pageDisplay);

  return (
    <React.Fragment>
      <ul className="pagination">
        <li className="page-item">
          <button
            className="page-link"
            onClick={() => {
              if (pageDisplay === "") {
                // setPageDisplay(pageIndex - 2);
              } else {
                // setPageDisplay((prevPageDisplay) => prevPageDisplay - 1);
              }
              onPreviousPageClick();
            }}
            disabled={!canPreviousPage}
          >
            Previous
          </button>
        </li>
        {pageOptions
          .slice(
            pageIndex >= 3
              ? pageIndex >= pageOptions.length - 2
                ? Math.max(0, pageOptions.length - 5)
                : pageIndex - 2
              : 0,
            pageIndex >= 3 ? pageIndex + 3 : 5
          )
          .map((val) => (
            <li
              key={val}
              className={pageIndex === val ? "page-item active" : "page-item"}
            >
              <button
                className="page-link"
                onClick={() => {
                  gotoPage(val);
                  // setPageDisplay(val + 1);
                }}
              >
                {val + 1}
              </button>
            </li>
          ))}
        <li className="page-item">
          <button
            className="page-link"
            onClick={() => {
              if (pageDisplay === "") {
                // setPageDisplay(pageIndex + 2);
              } else {
                // setPageDisplay((prevPageDisplay) => prevPageDisplay + 1);
              }
              onNextPageClick();
            }}
            disabled={!canNextPage}
          >
            Next
          </button>
        </li>
      </ul>
      <span>
        Page{" "}
        <strong>
          {pageIndex + 1} of {pageOptions.length > 0 ? pageOptions.length : 1}
        </strong>{" "}
      </span>
      <span>
        | Go to page:{" "}
        <input
          type="number"
          value={pageDisplay}
          onKeyDown={handleNumberOnClick}
          onChange={(e) => {
            if (e.target.value < 1 && e.target.value !== "") {
              return;
            }
            if (e.target.value === "") {
              setPageDisplay(e.target.value);
              gotoPage(0);
            }
            if (e.target.value !== "") {
              let pageToGo = Number(e.target.value);
              if (pageToGo > pageCount) {
                pageToGo = pageCount;
              }
              const page = pageToGo ? pageToGo - 1 : 0;
              gotoPage(page);
              setPageDisplay(pageToGo);
            }
          }}
          style={{ width: "100px" }}
        />
      </span>{" "}
      <select value={pageSize} onChange={setPageSize}>
        {[10, 20, 30, 40, 50].map((pageSize) => (
          <option key={pageSize} value={pageSize}>
            Show {pageSize}
          </option>
        ))}
      </select>
    </React.Fragment>
  );
};

export default TablePagination;
